(() => {
  document.querySelectorAll("[data-reiter-liste]").forEach((liste) => {
    const bereich = liste.closest("section") || document;
    const knoepfe = [...liste.querySelectorAll("[data-reiter]")];
    const zeigen = (id) => {
      knoepfe.forEach((k) => {
        const an = k.dataset.reiter === id;
        k.setAttribute("aria-selected", String(an));
        k.tabIndex = an ? 0 : -1;
        bereich.querySelectorAll(`[data-reiter-panel="${k.dataset.reiter}"], [data-reiter-pfeile="${k.dataset.reiter}"]`).forEach((el) => { el.hidden = !an; });
      });
    };
    liste.addEventListener("click", (e) => { const k = e.target.closest("[data-reiter]"); if (k) zeigen(k.dataset.reiter); });
    liste.addEventListener("keydown", (e) => {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      const i = knoepfe.indexOf(document.activeElement);
      if (i < 0) return;
      const n = knoepfe[(i + (e.key === "ArrowRight" ? 1 : knoepfe.length - 1)) % knoepfe.length];
      n.focus(); zeigen(n.dataset.reiter);
    });
  });
})();
